export type TCapacitorBridge = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
};

export function getCapacitorBridge(): TCapacitorBridge | undefined {
  if (typeof globalThis.window === 'undefined') return undefined;
  const w = globalThis.window as unknown as { Capacitor?: TCapacitorBridge };
  return w.Capacitor;
}

export function isCapacitorNativePlatform(): boolean {
  return getCapacitorBridge()?.isNativePlatform?.() === true;
}

export function getCapacitorPlatform(): string {
  return getCapacitorBridge()?.getPlatform?.() ?? 'web';
}
